const APPROVE_RESULTS = new Set([
  'accept',
  'approve',
  'approve/eligible',
  'accept/eligible',
  'eligible',
  'complete',
])

/**
 * Returns true when the DU result string indicates an approve/eligible outcome.
 * Case-insensitive. Returns false for null/undefined or any non-approve result.
 */
export function isAusResultApproved(
  result: string | null | undefined
): boolean {
  if (!result) return false
  return APPROVE_RESULTS.has(result.trim().toLowerCase())
}
